import dayjs from 'dayjs';
import { RESOURCE_LABELS } from './constants';

export const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = dayjs(value);
  return date.isValid() ? date.format('DD.MM.YYYY HH:mm') : value;
};

export const formatResource = (value) => {
  if (!value) return '-';
  return RESOURCE_LABELS[value] || value;
};

export const formatChannel = (value) => {
  if (value === 'stable') return 'Боевой';
  if (value === 'test') return 'Тестовый';
  return formatValue(value);
};

export const formatAddress = (address, apartment) => {
  const parts = [];
  if (address) parts.push(address);
  if (apartment !== null && apartment !== undefined && apartment !== '') parts.push(`кв. ${apartment}`);
  return parts.length ? parts.join(', ') : '-';
};

export const formatModuleFirmware = (firmware) => {
  if (!firmware || typeof firmware !== 'object') return '';
  return Object.entries(firmware)
    .filter(([, value]) => value !== null && value !== undefined && value !== '')
    .map(([key, value]) => `${key}: ${value}`)
    .join(', ');
};
